import { normalizeProviderName as fold } from './providerLogos';

/* Katalog kartındaki "Özel" rozeti.
 *
 * Sağlayıcılar bayiye özel masaları **oyunun adına markayı yazarak** verir
 * ("Auto Roulette <Marka>", "<Marka> Blackjack"), yani bilgi katalogda
 * zaten durur ve her senkronda kendiliğinden tazelenir. Panele ayrı bir
 * işaret koymak yöneticinin her yeni masada elle kutucuk işaretlemesi
 * demekti; unutulan kutucuk sessizce rozetsiz kalır ve "benim masam neden
 * özel görünmüyor" sorusu doğardı.
 *
 * Marka **koda gömülmez** — yazılım çok alıcıya satılıyor (bkz. CLAUDE.md →
 * "Marka: logo ve favicon"). Değer ayar kaydındaki site adından okunur;
 * ayarlar henüz gelmediyse `brandName` önbelleğe düşer ve rozet ilk
 * boyamada da doğru çizilir.
 */

// Ad karşılaştırması yazım farklarından arındırılmış hâl üzerindedir:
// sağlayıcı markayı boşluklu, tireli ya da büyük harfle yazabilir.
// `normalizeProviderName` tam da bunu yapar (NFKD → aksan at → küçült →
// harf/rakam dışını at) ve iki tarafa birden uygulandığı için Türkçe
// harflerin sadeleşmesi eşleşmeyi bozmaz.

// Kısa marka adı yanlış eşleşir: üç harfli bir marka sağlayıcının sıradan
// masasının adında da geçer ve bütün katalog "Özel" görünürdü.
const MIN_BRAND_LENGTH = 4;

/**
 * Masa kurulumun kendi markasıyla adlandırılmış mı?
 *
 * @param {string} gameName oyunun katalogdaki adı
 * @param {string} brand kurulumun site adı (`brandName(settings)`)
 */
export const isExclusiveGame = (gameName, brand) => {
  const needle = fold(brand);
  if (needle.length < MIN_BRAND_LENGTH) return false;
  return fold(gameName).includes(needle);
};

export default isExclusiveGame;
